/*
 * @Author: 李嘉宾 lijb@wisea.com.cn
 * @Date: 2024-07-16 10:32:44
 * @LastEditors: 李嘉宾 lijb@wisea.com.cn
 * @LastEditTime: 2024-09-19 15:22:43
 * @FilePath: \web\sznc_door\src\store\index.js
 * @Description: 
 * 
 * Copyright (c) 2024 by ${git_name_email}, All Rights Reserved. 
 */
import {createStore} from "vuex"

//创建store实例
const store=createStore({
    state(){
        return {
            "windowWidth":0,
            "theme":'',
            "module":"",
            "portalInfo":{},
            "color":"",
            "font":"",
            columnColor:'',
            columnFont:'',
            backgroundImage:'',
            columnBanner:''
        }
    },
    mutations:{
      widthChange(state,width) {
        // 变更状态
        state.windowWidth = width
      },
      setTheme(state,theme) {
        // 变更状态
        console.log(theme)
        state.theme = theme
      },
      setModule(state,module) {
        // 变更状态
        state.module = module
      },
      setColor(state,color) {
        // 变更状态
        state.color = color
      },
      setFont(state,font) {
        // 变更状态
        state.font = font
      },
      setPortalInfo(state,data) {
        // 变更状态
        state.portalInfo = data;
      },
      setColumnFont(state,columnFont) {
          // 变更状态
          state.columnFont = columnFont
      },
      setColumnColor(state,columnColor) {
          // 变更状态
          state.columnColor = columnColor
      },
      setBackgroundImage(state,backgroundImage) {
          // 变更状态
          state.backgroundImage = backgroundImage
      },
      setColumnBanner(state,data) {
        // 变更状态
        state.columnBanner = data;
      },
    }
})
export default store;